import { useEffect, useRef } from "react";
import { useScreenWakeLock } from "../hooks.ts";
import { Ean13 } from "./Ean13.tsx";
import { Icon } from "./icons.tsx";

/** Full-bleed white so the phone's backlight is all that stands between the bars and the till. */
export function CardFace({ card, label, onClose }: { card: string; label?: string; onClose: () => void }) {
	useScreenWakeLock(true);
	const close = useRef<HTMLButtonElement | null>(null);
	useEffect(() => {
		const previous = document.activeElement;
		close.current?.focus();
		const escape = (event: KeyboardEvent): void => {
			if (event.key === "Escape") onClose();
		};
		window.addEventListener("keydown", escape);
		return () => {
			window.removeEventListener("keydown", escape);
			if (previous instanceof HTMLElement && previous.isConnected) previous.focus();
		};
	}, [onClose]);
	return (
		<div className="cardface" role="dialog" aria-modal="true" aria-label={label ?? "Bonuskaart barcode"}>
			{label !== undefined && <p className="cardface-label">{label}</p>}
			<Ean13 value={card} />
			<p className="cardface-digits">{card}</p>
			<button ref={close} type="button" className="cardface-close" onClick={onClose}>
				<Icon name="close" /> Done
			</button>
		</div>
	);
}
